<ng-container *ngIf="isLegacy$ | async">
  <sbnb-hero-card
    [active]="(isDeviceAddonEnabled$ | async) && (canManageAddons$ | async) === true"
    [matTooltip]="(canManageAddons$ | async) === false ? 'Renew your subscription to add managed smart devices' : ''">
    <div class="flex flex-wrap justify-between gap-3">
      <div class="flex flex-col content flex-1 gap-3 max-w-[550px] min-w-[220px]">
        <h4 class="nomargin" [ngClass]="{ 'night-lighter': (canManageAddons$ | async) === false }">
          Managed Smart Devices
        </h4>
        <span>Manage all your devices, lock codes, and schedules from one place with our Smart Device Dashboard</span>
      </div>

      <ng-container *ngIf="(canManageAddons$ | async) === false || (isDeviceAddonEnabled$ | async) === false">
        <div *ngIf="smartDevicePrice$ | async as price">
          <sbnb-button
            [disabled]="(canManageAddons$ | async) === false"
            type="primary-teal"
            [routerLink]="['/settings', 'manage-device-addon']"
            [queryParams]="{ closeLink: '/settings/your-plan' }">
            Add for {{ price.formatted_string }}/device
          </sbnb-button>
        </div>
      </ng-container>
    </div>
  </sbnb-hero-card>
</ng-container>
